import { Alert, Link, TextField } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { useTexts } from './useTexts'
import { useResidentModalsApi } from '@/components/modals/ResidentModals'
import { useApiKey } from '../../../hooks/useApiKey'

export function Apikey() {
  const texts = useTexts()
  const { apiKey, apiKeyEnabled } = useApiKey()

  const {
    supportTicket: { show: showSupportTicketModal },
  } = useResidentModalsApi()

  return (
    <>
      <TextField
        label={texts.apiKey}
        disabled
        value={apiKeyEnabled ? apiKey : texts.ApiKeyNotSet}
      />
      {!apiKeyEnabled && (
        <Alert severity="info">
          <FormattedMessage
            id="settings.rmAccount.view.requestAPIKey"
            values={{
              a: chunks => (
                <Link
                  href="#"
                  onClick={() =>
                    showSupportTicketModal({
                      topic: 'API',
                      successMessage: texts.requestApiKeySuccess,
                    })
                  }
                >
                  {chunks}
                </Link>
              ),
            }}
          />
        </Alert>
      )}
    </>
  )
}
